import {
  CompanySettings,
  InvoicingDefaultLateMaxDaysTypeEnum,
} from '__generated__/GQL';

import { DEFAULT_LATE_MAX_DAYS } from '../../constants';
import getFortyFiveDaysEndOfMonth from '../getFortyFiveDaysEndOfMonth';

const LATE_MAX_DAYS_TYPE_MAP = {
  [InvoicingDefaultLateMaxDaysTypeEnum.Zero]: 0,
  [InvoicingDefaultLateMaxDaysTypeEnum.Seven]: 7,
  [InvoicingDefaultLateMaxDaysTypeEnum.Fourteen]: 14,
  [InvoicingDefaultLateMaxDaysTypeEnum.Fifteen]: 15,
  [InvoicingDefaultLateMaxDaysTypeEnum.TwentyOne]: 21,
  [InvoicingDefaultLateMaxDaysTypeEnum.Thirty]: 30,
};

const formatLateMaxDaysValue = (
  settings?: Pick<
    CompanySettings,
    'invoicingDefaultLateMaxDaysType' | 'invoicingDefaultLateMaxDaysOther'
  >,
  startAt?: number,
) => {
  if (!settings?.invoicingDefaultLateMaxDaysType || !startAt) {
    return DEFAULT_LATE_MAX_DAYS;
  }

  if (
    settings.invoicingDefaultLateMaxDaysType ===
    InvoicingDefaultLateMaxDaysTypeEnum.Other
  ) {
    // We add fallback to ensure typing but this case should not happen
    return settings.invoicingDefaultLateMaxDaysOther ?? DEFAULT_LATE_MAX_DAYS;
  }

  if (
    settings.invoicingDefaultLateMaxDaysType ===
    InvoicingDefaultLateMaxDaysTypeEnum.FortyFiveEndOfMonth
  ) {
    return getFortyFiveDaysEndOfMonth(new Date().valueOf());
  }

  return LATE_MAX_DAYS_TYPE_MAP[settings.invoicingDefaultLateMaxDaysType];
};

export default formatLateMaxDaysValue;
